import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 40,
	viewBox: "0 0 24 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1201_1683)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.2082 10.6714H0.708984V27.2302H21.2082V10.6714Z",
				fill: "#151728"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.0847 28.9836H9.60179C5.82249 28.9836 2.75879 25.9589 2.75879 22.2276V12.5959C2.75879 12.5021 2.83706 12.4248 2.9321 12.4248H23.0847C23.1797 12.4248 23.258 12.5021 23.258 12.5959V28.8125C23.258 28.9064 23.1797 28.9836 23.0847 28.9836Z",
				fill: "#E51834"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.0589 17.3867C15.3162 17.3867 15.5248 17.5927 15.5248 17.8467V20.7839L17.8043 18.5334C17.9863 18.3537 18.2813 18.3537 18.4632 18.5334C18.6452 18.713 18.6452 19.0042 18.4632 19.1839L16.1837 21.4344H19.1587C19.416 21.4344 19.6246 21.6404 19.6246 21.8944C19.6246 22.1484 19.416 22.3544 19.1587 22.3544H16.1837L18.4632 24.6049C18.6452 24.7846 18.6452 25.0758 18.4632 25.2554C18.2813 25.4351 17.9863 25.4351 17.8043 25.2554L15.5248 23.0049V25.9421C15.5248 26.1961 15.3162 26.4021 15.0589 26.4021C14.8016 26.4021 14.593 26.1961 14.593 25.9421V23.0049L12.3134 25.2554C12.1315 25.4351 11.8365 25.4351 11.6546 25.2554C11.4726 25.0758 11.4726 24.7846 11.6546 24.6049L13.9341 22.3544H10.9591C10.7018 22.3544 10.4932 22.1484 10.4932 21.8944C10.4932 21.6404 10.7018 21.4344 10.9591 21.4344H13.9341L11.6546 19.1839C11.4726 19.0042 11.4726 18.713 11.6546 18.5334C11.8365 18.3537 12.1315 18.3537 12.3134 18.5334L14.593 20.7839V17.8467C14.593 17.5927 14.8016 17.3867 15.0589 17.3867Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.90863 8.64746H6.11328V14.719H8.90863V8.64746Z",
				fill: "#101828"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.9037 8.64746H17.1084V14.719H19.9037V8.64746Z",
				fill: "#101828"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1201_1683",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgLogo;
